import { useMemo } from 'react';

import { useStatusContext } from 'pages/Status/context';

import { SUBTITLE } from './constants';

interface PaidByBankFinishedHook {
  subtitle: string;
}

export default function usePaidByBankFinished(): PaidByBankFinishedHook {
  const { jobCompanyInfo, isLoading } = useStatusContext();

  const companyName = useMemo(() => {
    if (!jobCompanyInfo || isLoading) return 'Your tradesperson';
    return jobCompanyInfo?.company_name || 'Your tradesperson';
  }, [jobCompanyInfo, isLoading]);

  const subtitle = useMemo(
    () => SUBTITLE.replace('$partner', companyName),
    [companyName],
  );

  return {
    subtitle,
  };
}
